import { useDispatch } from 'react-redux';
import { toggleModal } from 'state/callers';
import Background from 'components/Background';
import WelcomeBackground from 'images/characters/welcome-characters-background.svg';
import {
  createLinkAccountDoneModalOptions,
  createLinkAccountGitProviderDoneModalOptions,
  createPersonalAccessTokenModalOptions
} from 'modals/modal-options-factory';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { AUTH_LEVEL } from 'common/constants/constants';
import QueryString from 'qs';
import _ from 'lodash';
import { getProviderDetailsLinkAccount } from 'common/utils/provider.utils';

const styles = {
  background: `url(${WelcomeBackground}) no-repeat bottom right 7rem`,
  backgroundSize: `30rem`
};

const PATLinkAccount = ({ providerName }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const authFlow = location?.state?.authFlow;
  const authLevel = location?.state?.authLevel ?? AUTH_LEVEL.ORGANIZATION;
  const search = QueryString.parse(_.get(location, 'search'), {
    ignoreQueryPrefix: true
  });
  const baseUrl = search?.baseUrl;
  const providerDetails = getProviderDetailsLinkAccount(
    authFlow,
    authLevel,
    providerName,
    true
  );
  const dispatchModal = () => {
    dispatch(
      toggleModal(
        createPersonalAccessTokenModalOptions({
          provider: providerName,
          baseUrl,
          authorizationLevel: AUTH_LEVEL.INDIVIDUAL,
          onSubmit: ({ error }) =>
            dispatch(
              toggleModal(
                error
                  ? createLinkAccountDoneModalOptions({
                      provider: providerName,
                      baseUrl,
                      alwaysShowBack: false,
                      onBack: null,
                      isSensorAuth: false,
                      ...providerDetails
                    })
                  : createLinkAccountGitProviderDoneModalOptions({
                      provider: providerName,
                      baseUrl,
                      alwaysShowBack: false,
                      onBack: null,
                      ...providerDetails
                    })
              )
            ),
          onBack: null
        })
      )
    );
  };
  useEffect(() => {
    dispatchModal();
  }, []);

  return <Background styles={styles} />;
};
export default PATLinkAccount;
